$(function () {
  $('[data-behaviour~=check-card]').numeric({
        allowMinus: false
      , allowPlus: false
      , allowThouSep: false
      , allowDecSep: false
  })
  $('[data-behaviour~=check-name]').alphanum({
       allow: '-'
     , allowSpace: true
     , allowUpper: true
  });
  $('[data-behaviour~=check-address]').alphanum({
       allow: '/()?='
     , allowSpace: true
     , allowUpper: true
  });
  $('[data-behaviour~=check-taxnumber]').alphanum({
    allow              : '',    // Allow extra characters
    disallow           : '',    // Disallow extra characters
    allowSpace         : false,  // Allow the space character
    allowLatin         : true,  // a-z A-Z
    allowOtherCharSets : false,  // eg é, Á, Arabic, Chinese etc
    maxLength          : 16
  });
  $('[data-behaviour~=check-number]').alphanum({
       allow: '\\/-.'
     , allowSpace: true
     , allowUpper: true
  });
  $('input[name=profession_other], input[name=hobby_other], input[name=pets_other], input[name=stores_other], input[name=promotions_types_other]').on('blur', function (e) {
    var $this = $(e.target)
    if ($this.val()) {
      $this.prev('label').find('input').prop('checked', true)
    } else {
      $this.prev('label').find('input').prop('checked', false)
    }
  })
  $("[data-behaviour~=datepicker]").datepicker({
      'dayNamesMin': ["Do", "Lu", "Ma", "Me", "Gi", "Ve", "Sa"]
    , 'monthNames': ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"]
    , 'dateFormat': "dd/mm/yy"
  })
  $('input.autocap').autoCap()
})

jQuery.fn.autoCap = function () {
  $(this).each(function () {
    $(this).bind('keyup', function () {
      $(this).val($(this).val().toUpperCase())
    })
  })
}
